<template lang="html">
  <div class="container-pad">
    <rare-home-products-vantage :isHeader="true" @jumpToForm="jumpToForm" />

    <rare-call-out-box
      CallOutBody="Search 30,000+ law candidates by geography, demography, institution and academics. Looking for Sixth Form students in Manchester from a disadvantaged background? Non-Russell Group students with a 70 in Contract Law? STEM students with AAA or equivalent? Now you can find them and make direct contact."
      CallOutBodySmall="Search 27,000+ law candidates by geography, demography, institution and academics. Looking for Sixth Form students in Manchester from a disadvantaged background? Non-Russell Group students with a 70 in Contract Law? STEM students with AAA or equivalent? Now you can find them and make direct contact."
      CallOutColor="grey"
    />

    <testimonial-carousel
          :slides="slides"
    />

    <quotes-carousel />

    <rare-call-out-box
      CallOutTitle="World-class security"
      IsH1
      Lowercase
      CallOutBody="Vantage has platinum-level information security with ISO27001 accreditation. Candidate data is safe
      with us."
      CallOutBodySmall="Vantage has platinum-level information security with ISO27001 accreditation. Candidate data is safe
      with us."
      CallOutColor="white"
    />

    <rare-call-out-box
      CallOutTitle="Want to join Vantage?"
      IsH1
      Lowercase
      CallOutBody=""
      CallOutBodySmall=""
      CallOutColor="midgrey"
      :ButtonShow="true"
      ButtonText="Sign up"
      ButtonLink="https://portal.vantageapp.io/signup"
    />

    <rare-contact-form :product="'Vantage'" />

    <rare-awards/>
  </div>
</template>

<script>

import Frankie from '@/assets/img/photos/testimonials/vantage/Frankie-Dadzie.jpg';
import Thomas from '@/assets/img/photos/testimonials/vantage/Thomas.png';
import Sayed from '@/assets/img/photos/testimonials/vantage/Sayed.png';

import FreshFields from '@/assets/img/logos/testimonial-logos/freshfields.png';
import Linklaters from '@/assets/img/logos/testimonial-logos/linklaters.png';
import TraversSmith from '@/assets/img/logos/testimonial-logos/traverssmith.png';

import RareCallOutBox from '../../../components/commonSections/RareCallOutBox';
import RarePersonQuote from '../../../components/commonSections/RarePersonQuote';
import QuotesCarousel from '../../../components/carousels/quotesCarousel';
import RareContactForm from '../../../components/forms/RareContactForm';
import RareAwards from '../../../components/carousels/awardsCarousel';
import VantageTestimonialCarousel from '../../../components/carousels/testimonialCarousel/testimonialCarousel';

import RareHomeProductsVantage from '../components/RareHomeProductsVantage';

export default {
  name: 'homeProductsCandidAts',
  props: {
  },
  components: {
    'rare-call-out-box': RareCallOutBox,
    'rare-person-quote': RarePersonQuote,
    'quotes-carousel': QuotesCarousel,
    'rare-home-products-vantage': RareHomeProductsVantage,
    'rare-contact-form': RareContactForm,
    'rare-awards': RareAwards,
    'testimonial-carousel': VantageTestimonialCarousel,
  },
  data() {
    return {
      slides: [
        {
          quote: 'Vantage is brilliant! The fact that we can contact students directly, in such a targeted way, really improves the quality of our interactions as it allows us to send very specific messages about opportunities relevant to each individual. It’s also easy to track, so we can see the impact of using Vantage almost instantly.',
          img: Frankie,
          name: 'Frankie Dadzie',
          position: 'Trainee Recruitment Marketing & Attraction Lead',
          logo: Linklaters,
          id: 0,
        },
        {
          quote: 'Vantage helps us to target specific demographics of students directly, meaning that we are able to build a diverse pipeline of candidates… It has been a great addition to our candidate attraction as we can directly share opportunities that are most relevant for individual candidates who may otherwise have never applied to Travers Smith.',
          img: Thomas,
          name: 'Thomas Hogan',
          position: 'Early Careers Advisor',
          logo: TraversSmith,
          id: 1,
        },
        {
          quote: 'Vantage has revolutionized our strategy for attracting and engaging talent, fundamentally transforming the landscape of early careers recruitment. It has quickly become our primary tool for promoting events and opportunities. The impact of a ‘Vantage Blast’ can be seen almost immediately.',
          img: Sayed,
          name: 'Sayed Aasim Qadri',
          position: 'Early Careers Senior Recruitment Specialist',
          logo: FreshFields,
          id: 2,
        },
      ],
    };
  },
  created() {
  },
  destroyed() {
  },
  mounted() {
  },
  methods: {
    jumpToForm() {
      const element = document.getElementById('rare-contact-form');
      const y = element.getBoundingClientRect().top + (window.pageYOffset - 330);

      const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

      if (isIE11 === true) {
        document.getElementById('validationAnchor').scrollIntoView();
      } else {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

.container-pad {
  padding-top: 80px;
}

</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsVantage/homeProductsVantage.vue